/**
 * Tooltip 渲染模块。
 * 专注于根据 columns/records 生成 HTML 结构，避免夹杂数据准备或排序逻辑。
 * 后续若需要扩展渲染样式或布局，请在此文件维护。
 */
import classNames from 'classnames';
import {
  IChartTooltipConfig,
  IColumn,
  ITooltipRecord,
} from '@customComp/Chart/chartConfigs/types';

export const generateTooltipGrid = <TRecord extends ITooltipRecord>(
  columns: IColumn<TRecord>[],
  records: TRecord[],
  config?: IChartTooltipConfig,
): string => {
  const { footer = '' } = config || {};

  const columnCount = columns.length;

  const headerHtml = columns
    .map(
      (column) =>
        `<div class="dbl-new-chart-tooltip-header-cell" style="text-align: ${column.align || 'left'}">${column.header}</div>`,
    )
    .join('');

  const dataHtml = records
    .map((record) =>
      columns
        .map((column) => {
          const className = classNames('dbl-new-chart-tooltip-body-cell', column.className);
          if (typeof column?.render === 'function') {
            const renderedContent = column.render(record[column.key], record, column);
            return `<div class="${className}" style="justify-self: ${
              column.align || 'start'
            }">${renderedContent}</div>`;
          }
          return `<div class="${className}" style="justify-self: ${
            column.align || 'start'
          }">${record[column.key] || ''}</div>`;
        })
        .join(''),
    )
    .join('');
  
  return `<div class="dbl-new-chart-tooltip" style="grid-template-columns: repeat(${columnCount}, max-content);">
    ${headerHtml}
    ${dataHtml}
    ${
  footer
    ? `<div class="dbl-new-chart-tooltip-footer" style="grid-column: span ${columnCount};">${footer}</div>`
    : ''
}
  </div>`;
};
